import * as Yup from "yup";

export function initialValues(user) {
  return {
    avatar: user?.avatar || "",
    fileAvatar: null,
    firstname: user?.firstname || "",
    lastname: user?.lastname || "",
    secondLastname: user?.secondLastname || "",
    dni: user?.dni || "",
    email: user?.email || "",
    phone: user?.phone || "",
    phone2: user?.phone2 || "",
    gender: user?.gender || "",
    roleId: user?.roleId || "",
    password: "",
    active: user?.active || true
  };
}

export function validationSchema(user) {
  return Yup.object({
    firstname: Yup.string().required("El nombre es obligatorio"),
    lastname: Yup.string().required("El apellido paterno es obligatorio"),
    secondLastname: Yup.string().required("El apellido materno es obligatorio"),
    dni: Yup.number().required("El DNI es obligatorio"),
    email: Yup.string().email(true).required("El correo electrónico es obligatorio"),
    phone: Yup.number().required("El teléfono es obligatorio"),
    gender: Yup.string().required("El género es obligatorio"),
    roleId: Yup.string().required("El rol es obligatorio"),
    password: user ? Yup.string() : Yup.string().required("La contraseña es obligatoria"),
  });
}
